// extracted by mini-css-extract-plugin
export default {"button_styles":"Button_button_styles__x5S-s"};